import { ExternalToast, toast as sonner } from "sonner";
import { XIcon } from "lucide-react";

type Options = ExternalToast & {
  onAction?(): void;
};

const DEFAULT_DURATION = 4000;

export const toast = {
  success(message: string, options?: Options) {
    const id = sonner.success(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon className="w-4 h-4" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  warning(message: string, options?: Options) {
    const id = sonner.warning(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon className="w-4 h-4" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  error(message: string, options?: Options) {
    const id = sonner.error(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon className="w-4 h-4" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  info(message: string, options?: Options) {
    const id = sonner.info(message, {
      duration: DEFAULT_DURATION,
      action: {
        label: <XIcon className="w-4 h-4" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  dismiss(id: string | number) {
    sonner.dismiss(id);
  },
};
